import React from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useStyles } from "./mobile-filter-modal.styles";

type FocusAreasType = {
  focusAreaId: number;
  name: string;
};

type FiltersType = {
  focusAreaId: string;
  sortBy: string;
};

interface MobileFiltersModalProps {
  open: boolean;
  handleClose: () => void;
  focusAreas: FocusAreasType[];
  filters: FiltersType;
  setFilters: (filters: FiltersType) => void;
  debouncedHandleFilterChange: (focusId: string, focusAreaId: string) => void;
  debouncedHandleSortChange: (focusId: string, focusAreaId: string) => void;
}

export const MobileFiltersModal = ({
  open,
  handleClose,
  focusAreas,
  filters,
  setFilters,
  debouncedHandleFilterChange,
  debouncedHandleSortChange,
}: MobileFiltersModalProps) => {
  const classes = useStyles();
  const handleSubmitFilters = () => {
    debouncedHandleFilterChange(filters.focusAreaId, "focusAreaId");
    const orderBy = filters?.sortBy === "date" ? "dueDate" : "origin";
    const sortBy = filters?.sortBy === "date" ? "desc" : "asc";
    debouncedHandleSortChange(orderBy, sortBy);
    handleClose();
  };

  const handleFiltersChange = (event) => {
    const { value, name } = event.target;
    setFilters({ ...filters, [name]: value });
  };
  const handleSortChange = (event) => {
    const { value, name } = event.target;
    setFilters({ ...filters, [name]: value });
  };

  const initialFilters = { focusAreaId: "", sortBy: "" };

  const handleClearFilters = () => {
    setFilters(initialFilters);
  };

  const closeFiltersModal = () => {
    setFilters(initialFilters);
    handleClose();
  };

  const focusAreasLabels = () => {
    return focusAreas.map(({ focusAreaId, name }) => (
      <FormControlLabel
        className={classes.filtersItems}
        key={focusAreaId}
        value={focusAreaId.toString()}
        control={<Radio color="default" />}
        label={name}
      />
    ));
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className={classes.container}>
        <Grid container>
          <IconButton onClick={closeFiltersModal}>
            <ArrowBackIosIcon />
          </IconButton>
          <Typography className={classes.titleSection}>Filters</Typography>
        </Grid>

        <form className={classes.filtersForm} onSubmit={handleClearFilters}>
          <FormControl component="fieldset">
            <Typography className={classes.filterLabel}>Focus Area</Typography>
            <RadioGroup
              aria-label="focusAreaId"
              name="focusAreaId"
              value={filters?.focusAreaId}
              onChange={handleFiltersChange}
            >
              {focusAreasLabels()}
            </RadioGroup>
            <Typography className={classes.filterLabel}>Sort</Typography>
            <RadioGroup
              aria-label="sortBy"
              name="sortBy"
              value={filters?.sortBy}
              onChange={handleSortChange}
            >
              <FormControlLabel
                value="type"
                control={<Radio color="default" />}
                label="Type"
              />
              <FormControlLabel
                value="date"
                control={<Radio color="default" />}
                label="Date"
              />
            </RadioGroup>
            <Grid
              className={classes.buttonsContainer}
              container
              direction="row"
              justifyContent="space-evenly"
              alignItems="center"
            >
              <Button onClick={handleClearFilters} variant="outlined">
                Clear all
              </Button>
              <Button
                onClick={handleSubmitFilters}
                variant="outlined"
                color="primary"
              >
                Finished
              </Button>
            </Grid>
          </FormControl>
        </form>
      </Box>
    </Modal>
  );
};
